import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { QuestionForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { question, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Questions", link: "/question" },
                { name: "Edit", link: "" },
                { name: question?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Question" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Question Update"}
                        bordered={true}
                    >
                        {question && (
                            <QuestionForm
                                question={question}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
